globalThis.exportExcelActionCable = function($html) {

  var $btn         = $html.find(".btn.channel-submit"),
      $loader      = "<i class='fa fa-spinner fa-spin'></i>",
      $success     = "<i class='fa fa-check position-left'></i> Téléchargé avec succès !",
      $glyph       = $btn.find("i"),
      connectedKey = $btn.data("current-connected-key");

  if($btn.length) {
    var channel = globalThis.App.cable.subscriptions.create({
     channel: 'CustomerSpace::InteractionsExcelExportChannel',
     current_connected_key: connectedKey
    }, {
     received: function(data) {
      if(data.export_finished) {
        $btn.prop("disabled", true).removeClass("btn-primary").addClass("btn-success disabled").html($success);
        appCustomerSpace.Loader().stop();
        globalThis.App.cable.disconnect();
      }
     }
    });

    $($html).on("click", ".btn.channel-submit", function(e) {
      $this = $(this);
      $this.removeClass("btn-default channel-submit").addClass("btn-primary");
      $this.html($loader);
    });
  }

}
